import Marquee from "react-fast-marquee";
import {
  selectMainState,
  setViewRadioPlayer,
} from "../../../../store/slices/main";
import { useAppDispatch, useAppSelector } from "../../../../hooks/redux-hooks";
import EfirControl from "../../../common/player/radioPlayer/fullScreenRadioPlayer/components/EfirControl";
import ControlButton from "../../../common/player/components/ControlButton";

const DesctopHeaderPlayer = () => {
  const dispatch = useAppDispatch();
  const {
    radioPlayer: { metadata, player, radio, playForTrack, preRollPlayed },
    audioPlayer,
  } = useAppSelector(selectMainState);

  return (
    <>
      {player && (
        <div className="w-full flex items-start h-[3.5rem] rounded-md justify-end">
          <div className="w-full flex flex-col justify-end md:max-w-[11rem] lg:max-w-full">
            <div className="max-w-[17.3rem] w-full h-full flex justify-end items-center">
              <EfirControl
                isMetadataActive={!!metadata}
                isRadioActice={radio}
              />
            </div>
            <div
              className="pt-0.5 overflow-hidden text-ellipsis line-clamp-1 w-full"
              onClick={() => {
                audioPlayer.overTop
                  ? dispatch(setViewRadioPlayer(true))
                  : dispatch(setViewRadioPlayer(false));
              }}
            >
              <h4
                className={`max-w-[17.3rem] text-base font-bold text-right transition-transform duration-500`}
              >
                {radio && !playForTrack ? (
                  <span>
                    {metadata.length > 21 ? (
                      <Marquee
                        pauseOnHover={true}
                        speed={20}
                        style={{ width: "100%" }}
                      >
                        <span className="pr-5">{metadata}</span>
                        <span className="pr-5">{metadata}</span>
                        <span className="pr-5">{metadata}</span>
                      </Marquee>
                    ) : (
                      <>{metadata}</>
                    )}
                  </span>
                ) : preRollPlayed ? (
                  <span>РЕКЛАМА</span>
                ) : (
                  <span>РАДІО «СІЛЬПО»</span>
                )}
              </h4>
            </div>
          </div>
          <ControlButton main={true} player={player} />
        </div>
      )}
    </>
  );
};

export default DesctopHeaderPlayer;
